export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Newsletter Section */}
      <div className="bg-cyan-600 py-16">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl md:text-4xl font-black mb-4 uppercase tracking-tight">
              JOIN THE CREW
            </h3>
            <p className="text-lg mb-8 text-white/90">
              Get exclusive access to new releases, pro tips, and special offers
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
              <input 
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-4 rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
              />
              <button 
                type="submit"
                className="bg-gray-900 hover:bg-gray-800 text-white px-10 py-4 rounded-md font-bold transition-colors cursor-pointer whitespace-nowrap uppercase tracking-wider"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <img 
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/30692f87ee96eca30e78f5feb62e78d5.png" 
              alt="AQUATEK" 
              className="h-6 mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Premium fishing gear and apparel designed for serious anglers who demand the best.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Shop</h4>
            <ul className="space-y-3">
              <li><a href="/products?category=shirts" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Shirts</a></li>
              <li><a href="/products?category=shorts" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Shorts</a></li>
              <li><a href="/products?category=jackets" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Jackets</a></li>
              <li><a href="/products?category=pants" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Pants</a></li>
              <li><a href="/products?category=hats" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Hats</a></li>
              <li><a href="/products?category=drinkware" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Drinkware</a></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Support</h4>
            <ul className="space-y-3">
              <li><a href="#contact" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Contact Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Shipping Info</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Returns</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Size Guide</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">FAQ</a></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              <li><a href="#about" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Our Story</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Ambassadors</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Press</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 AQUATEK. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}